"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _react = _interopRequireDefault(require("react"));
var _HiSuggestSelectField = _interopRequireDefault(require("../HiSelect/HiSuggestSelectField"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // @inheritedComponent HiSuggestSelectField
// OpenStreeMap API url
var API_URL = 'https://nominatim.openstreetmap.org/search?q=';

/**
 * Champs input adresse pour formulaire
 */
var HiAddressField = /*#__PURE__*/function (_React$Component) {
  function HiAddressField(props) {
    var _this;
    (0, _classCallCheck2.default)(this, HiAddressField);
    _this = _callSuper(this, HiAddressField, [props]);
    _this.displaySuggestions = function (predictions) {
      var options = [];
      var isExact = false;
      predictions.forEach(function (prediction) {
        // Si le texte saisi est identique à une des propositions, on estime que la valeur de l'adresse est exacte.
        isExact = prediction.display_name === _this.state.inputValue ? true : isExact;
        options.push({
          id: prediction.place_id,
          label: prediction.display_name,
          labelHighlight: prediction.display_name.replace(new RegExp(_this.value, 'gi'), '<strong>$&</strong>'),
          // Liste des types d'adresse : https://github.com/openstreetmap/Nominatim/blob/80df4d3b560f5b1fd550dcf8cdc09a992b69fee0/settings/partitionedtags.def
          icon: ['amenity', 'building'].includes(prediction.category) ? 'domain' : 'place',
          type: 'icon',
          key: prediction.id
        });
      }, _this);
      _this.setState({
        options: options,
        isExact: isExact
      });
    };
    _this.state = {
      inputValue: null,
      options: [],
      isExact: false
    };
    _this.handleSearch = _this.handleSearch.bind(_this);
    _this.handleSelect = _this.handleSelect.bind(_this);
    _this.handleReset = _this.handleReset.bind(_this);
    _this.displaySuggestions = _this.displaySuggestions.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(HiAddressField, _React$Component);
  return (0, _createClass2.default)(HiAddressField, [{
    key: "handleSearch",
    value: function handleSearch(event) {
      var _this2 = this;
      if (event.target.value) {
        this.setState({
          inputValue: event.target.value
        });
        fetch("".concat(API_URL, " + ").concat(this.state.inputValue, " + &format=jsonv2&limit=5&bounded=1&dedupe=1&namedetails=1")).then(function (result) {
          return result.json();
        }).then(function (data) {
          _this2.displaySuggestions(data, 'OK');
        });
      } else {
        this.setState({
          options: []
        });
      }
      this.props.onSearch(event);
    }
  }, {
    key: "handleReset",
    value: function handleReset() {
      this.props.onReset();
      this.setState({
        options: [],
        isExact: false
      });
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(event, value) {
      // Mise à jour de la valeur du champ + la valeur de l'adresse est exacte
      this.setState({
        options: [],
        isExact: true
      });
      this.props.onSelect(event, value.label);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        exactOnly = _this$props.exactOnly,
        onSearch = _this$props.onSearch,
        onReset = _this$props.onReset,
        onSelect = _this$props.onSelect,
        otherProps = (0, _objectWithoutProperties2.default)(_this$props, ["exactOnly", "onSearch", "onReset", "onSelect"]);
      var _this$state = this.state,
        options = _this$state.options,
        isExact = _this$state.isExact; // On met le champ en erreur si une adresse exacte est éxigée
      // et si l'adresse courante n'est pas complète
      var showError = exactOnly && !isExact;
      return /*#__PURE__*/_react.default.createElement(_HiSuggestSelectField.default, (0, _extends2.default)({
        error: showError,
        options: options,
        onSearch: this.handleSearch,
        onSelect: this.handleSelect,
        onReset: this.handleReset,
        isExact: isExact
      }, otherProps));
    }
  }]);
}(_react.default.Component);
var _default = exports.default = HiAddressField;